'use strict';

var React = require('react');

var SvgCapturePaymentMinor = function SvgCapturePaymentMinor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M15 9a2 2 0 1 1-.001 4.001 2 2 0 0 1 .001-4.001zm-5 0a2 2 0 1 1 .001-4.001 2 2 0 0 1-.001 4.001zm6-7a2 2 0 1 1-.001 4.001 2 2 0 0 1 .001-4.001zm-3 14a1 1 0 1 1 0 2h-6a.998.998 0 0 1-.243-.03l-4-1a1 1 0 0 1-.757-.97v-3c0-.431.275-.813.684-.948l3-1a.947.947 0 0 1 .294-.047c.007-.001.014-.005.022-.005h3a1 1 0 1 1 0 2h-1.834c.599 1.807 2.828 3 5.834 3z"
  }));
};

exports.SvgCapturePaymentMinor = SvgCapturePaymentMinor;
